/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import Pagination from "./pagination";

const Swipeable = ({
    children,
    options = {},
    onChangeIndexCallback = () => {},
    selectedIndex = 0,
    showSelectedIndex = false,
    index,
    onPreviousCallback,
    onNextCallback,
    onSwitching = () => {},
    ...restProps
}) => {
    const sliderRef = useRef(null);

    const isControlledByIndex = typeof index === "number";
    const isControlledBySelected = showSelectedIndex && typeof selectedIndex === "number";

    const initial = isControlledByIndex
        ? index
        : isControlledBySelected
            ? selectedIndex
            : 0;

    const [swipeIndex, setSwipeIndex] = useState(initial);

    // keep slick in sync when controlled
    useEffect(() => {
        if (isControlledByIndex) {
      sliderRef.current?.slickGoTo(index, true);
      setSwipeIndex(index);
        }
    }, [isControlledByIndex, index]);

    useEffect(() => {
        if (isControlledBySelected) {
      sliderRef.current?.slickGoTo(selectedIndex, true);
      setSwipeIndex(selectedIndex);
        }
    }, [isControlledBySelected, selectedIndex]);

    const handleAfterChange = (i) => {
        setSwipeIndex(i);
        onChangeIndexCallback(i);
    };

    const {
        enableArrows,
        enableDots,
        enablePagination = true,
        arrowColor,
        allActive,
        ...slickOptions
    } = options || {};

    const settings = {
        ...slickOptions,
        centerMode: false,
        initialSlide: initial,
        beforeChange: (_curr, next) => onSwitching(_curr, next),
        afterChange: handleAfterChange,
        dots: enableDots,
        arrows: enableArrows,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        draggable: true,
        swipeToSlide: true,
        waitForAnimate: false,
        touchThreshold: 8,
        ...restProps
    };

    const dotsCount = React.Children.count(children);

    return (
        <><Slider ref={sliderRef} {...settings}>
            {React.Children.map(children, (child, i) => {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, { key: child.key !== null ? child.key : i });
                }
                return child;
            })}
        </Slider>{enablePagination && (
            <Pagination
                enableArrows={enableArrows}
                enableDots={enableDots}
                dots={dotsCount}
                index={swipeIndex}
                onChangeIndex={(i) => sliderRef.current?.slickGoTo(i)}
                arrowColor={arrowColor}
                allActive={allActive}
                onPreviousCallback={onPreviousCallback}
                onNextCallback={onNextCallback}
            />
        )}</>
    );
};

Swipeable.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    options: PropTypes.object,
    onChangeIndexCallback: PropTypes.func,
    selectedIndex: PropTypes.number,
    showSelectedIndex: PropTypes.bool,
    index: PropTypes.number,
    onPreviousCallback: PropTypes.func,
    onNextCallback: PropTypes.func,
    onSwitching: PropTypes.func
};

export default Swipeable;
